import {Product} from "../../models/product";
import {VoucherTemplate} from "../../models/voucherTemplate";
import {User} from "../../models";

export class VirtualReceiptItem {
    id: string;
    product?: Product;
    voucher?: VoucherTemplate;
    quantity: number;
    createdAt: string;
    updatedAt: string;
    createdBy: User;
    updatedBy: User;
}
